<template>
    <div
      :class="['modal', 'modal-inbound-container']"
      id="modalInbound"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-inbound">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title modal-large-p-no" id="staticBackdropLabel" v-html="this.intl[this.$store.state.lang]['header']"></h5>
            <button
              type="button"
              class="btn-close"
              @click="closeModal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" v-html="this.intl[this.$store.state.lang]['body']"></div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeModal"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalInbound">
    Launch static backdrop modal
    </button> -->
  </template>

<script>
import intl from "./intl/intl";
import { Modal } from 'bootstrap';
export default {
  name: "modalInbound",
  props: {
    inboundMinutesTimer: {
      type: String,
      default: '2',
    },
  },
  data() {
    return {
      intl: intl,
      inactivityTimeout: null,
      modalInstance: null,
      showModal: false
    };
  },
  mounted() {
    this.modalInstance = new Modal(document.getElementById('modalInbound'));
    if(!this.inboundChiuso){
        this.resetInactivityTimer();
        window.addEventListener('mousemove', this.resetInactivityTimer);
        window.addEventListener('keydown', this.resetInactivityTimer);
    }
    
  },
  beforeUnmount() {
    if(!this.inboundChiuso){
        window.removeEventListener('mousemove', this.resetInactivityTimer);
        window.removeEventListener('keydown', this.resetInactivityTimer);
        this.clearInactivityTimer();
    }
  },
  computed: {
    modalTimeout() {
        let minuti = parseFloat(this.inboundMinutesTimer)
        if(this.$store.state.libraryWiperConfig?.minutiTimerInbound && !isNaN(parseFloat(this.$store.state.libraryWiperConfig.minutiTimerInbound))){
            minuti = parseFloat(this.$store.state.libraryWiperConfig.minutiTimerInbound)
        }
        return minuti * 60 * 1000
    },
    inboundChiuso(){
      let inboundChiuso = true
      if(this.$store.state.libraryWiperConfig?.chiudiInbound === "NO"){
        inboundChiuso= false
      } else if(this.$store.state.libraryWiperConfig.chiudiInbound === "SI"){
        let inboundDal = this.$store.state.libraryWiperConfig.chiudiInboundDal
        let inboundAl = this.$store.state.libraryWiperConfig.chiudiInboundAl
        
        if(!inboundDal && !inboundAl){
            inboundChiuso = true
        }else{
          let today = new Date()
          if(inboundDal && inboundAl){
            inboundChiuso = today >= new Date(inboundDal) && today <= new Date(inboundAl)
          }else if(inboundDal){
            inboundChiuso = today >= new Date(inboundDal)
          }else if(inboundAl){
            inboundChiuso = today <= new Date(inboundAl)
          }
        }
      }
      return inboundChiuso
    },
  },
  methods: {
    resetInactivityTimer() {
      this.clearInactivityTimer();
      this.inactivityTimeout = setTimeout(() => {
        document.getElementById('modalInbound').classList.add('in');
        this.modalInstance.show();
      }, this.modalTimeout);
    },
    clearInactivityTimer() {
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout);
      }
    },
    closeModal() {
        document.getElementById('modalInbound').classList.remove('in');
      this.modalInstance.hide();
      this.resetInactivityTimer();
    },
  },
};
</script>